import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { FormError } from '~/components/form/FormError';
import Dialog from '@mui/material/Dialog';
import { Checkbox, DialogContent, DialogTitle, FormControl, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from '@mui/material';
import clsx from 'clsx';
import { usePatientReportMutation } from '~/api/patientReports/usePatientReportMutation';
import { CachedOutlined, Check, Close } from '@mui/icons-material';
import Button from '@mui/material/Button';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { ReviewTimer } from "~/components/patientReports/ReviewTimer";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
const formSchema = yup
    .object({
    talkType: yup.string().required('Select a value'),
    timeSpent: yup.string().required('Select a value'),
    programType: yup.string().required('Select a value')
})
    .required();
export const ConfirmAnalysisModal = (props) => {
    const { onRequestClose, reportID, sensorReview, providerNames, followUpDate, patientId, patient } = props;
    const [selectedDate, setSelectedDate] = React.useState(dayjs(new Date()));
    const [isTimeOther, setIsTimeOther] = useState(false);
    const [personName, setPersonName] = React.useState([]);
    const [selectedFollowUpDate, setSelectedFollowUpDate] = React.useState(null);
    const [openFollowUpCalendar, setOpenFollowUpCalendar] = useState(false);
    const [overrideValue, setOverrideValue] = useState(null);
    const [ccmProgramDisabled, setCcmProgramDisabled] = useState(false);
    const [rpmProgramDisabled, setRpmProgramDisabled] = useState(false);
    const [programSelectorVisible, setProgramSelectorVisible] = useState(true);
    const [disableDoneButtonByDate, setDisableDoneButtonByDate] = useState(false);
    console.log('reportId');
    console.log(reportID);
    const getTimerValue = () => {
        const storageKey = `patient-timer-${patientId}`;
        console.log('Storage Key:');
        console.log(storageKey);
        const timerData = sessionStorage.getItem(storageKey);
        console.log(timerData);
        if (timerData) {
            const parsed = JSON.parse(timerData);
            const now = Date.now();
            let elapsed = now - parsed.startTime - parsed.totalPausedTime;
            if (!parsed.isRunning && parsed.lastPauseTime) {
                elapsed -= (now - parsed.lastPauseTime);
            }
            const minutes = Math.max(0, elapsed / 60000);
            return parseFloat(minutes.toFixed(2));
        }
        return 0;
    };
    const methods = useForm({
        resolver: yupResolver(formSchema),
        defaultValues: {
            talkType: '',
            timeSpent: getTimerValue(),
            timeOther: undefined,
            programType: ''
        }
    });
    const { formState: { isSubmitting, errors }, handleSubmit, register, watch, setValue } = methods;
    const timeChanged = watch('timeSpent');
    const timeOther = watch('timeOther');
    useEffect(() => {
        if (timeChanged == -1) {
            setIsTimeOther(true);
        }
        else {
            setIsTimeOther(false);
        }
        if (timeChanged == -1 && timeOther && !isNaN(Number(timeOther))) {
            setOverrideValue(Number(timeOther));
        }
    }, [timeChanged, timeOther]);
    useEffect(() => {
        if (followUpDate) {
            setSelectedFollowUpDate(dayjs(followUpDate));
        }
        if (patient.ccmConsent && !patient.rpmConsent) {
            setValue('programType', 'CCM');
            setRpmProgramDisabled(true);
        }
        if (!patient.ccmConsent && patient.rpmConsent) {
            setValue('programType', 'RPM');
            setCcmProgramDisabled(true);
        }
        if (!patient.ccmConsent && !patient.rpmConsent && patient.cgmConsent) {
            setValue('programType', 'CGM');
            setProgramSelectorVisible(false);
        }
    }, []);
    useEffect(() => {
        if (selectedDate) {
            // all practices need end of month disabled
            const lastDayOfMonth = selectedDate.endOf('month');
            if (selectedDate.isSame(lastDayOfMonth, 'day')) {
                if (patient.rpmConsent) {
                    setDisableDoneButtonByDate(true);
                }
                else {
                    setDisableDoneButtonByDate(false);
                }
            }
            else {
                setDisableDoneButtonByDate(false);
            }
            // some practices need more days disabled
            const dateToDisable = dayjs('2026-04-01');
            const dateToDisable1 = dayjs('2026-05-01');
            // const dateToDisable1 = dayjs('2026-09-17');
            // these practice ids we do not want to disable on april 1 or may 1
            const practiceIdsToNotDisable = ['23', '30', '33', '34', '35', '36'];
            if (selectedDate.isSame(dateToDisable, 'day') || selectedDate.isSame(dateToDisable1, 'day')) {
                if (patient.practiceId) {
                    if (practiceIdsToNotDisable.includes(patient.practiceId)) {
                        setDisableDoneButtonByDate(false);
                    }
                    else {
                        if (patient.rpmConsent) {
                            setDisableDoneButtonByDate(true);
                        }
                        else {
                            setDisableDoneButtonByDate(false);
                        }
                    }
                }
            }
        }
    }, [selectedDate]);
    const { mutateAsync } = usePatientReportMutation();
    const onNewPatientFormSubmit = async ({ timeOther, talkType, timeSpent, programType }) => {
        console.log('Selected Superivising: ');
        console.log(personName);
        const data = {
            talkType: talkType == '' ? null : talkType,
            timeSpent: timeSpent == 0 ? null : timeSpent,
            timeOther: timeOther == 0 ? null : timeOther,
            programType: programType == '' ? null : programType
        };
        let talkTypeBool = false;
        if (data.talkType === 'Yes') {
            talkTypeBool = true;
        }
        let finalTimeSpent;
        if (timeSpent === undefined || timeSpent === null) {
            // No radio button selected - use timer value (default behavior)
            finalTimeSpent = getTimerValue();
        }
        else if (timeSpent === -1) {
            // "Other" option selected
            if (!timeOther) {
                alert('Please enter a time');
                return;
            }
            finalTimeSpent = timeOther;
        }
        else {
            // Preset time selected (5, 10, 15, 20)
            finalTimeSpent = timeSpent;
        }
        if (timeChanged == -1) {
            if (!timeOther) {
                alert('Please enter a time');
            }
            else {
                onRequestClose();
                const result = await mutateAsync({
                    id: reportID,
                    offline: false,
                    inOffice: false,
                    glucoseSensorReview: sensorReview,
                    didTalk: talkTypeBool,
                    timeSpent: timeOther,
                    activityDate: selectedDate,
                    supervisingProvider: personName[0],
                    followUpDate: selectedFollowUpDate,
                    programType: programType
                });
                sessionStorage.setItem("wasReloaded", "true");
                const storageKey = `patient-timer-${patientId}`;
                sessionStorage.removeItem(storageKey);
                window.location.reload();
                return result;
            }
        }
        else {
            onRequestClose();
            const result = await mutateAsync({
                id: reportID,
                offline: false,
                inOffice: false,
                glucoseSensorReview: sensorReview,
                didTalk: talkTypeBool,
                timeSpent: finalTimeSpent,
                activityDate: selectedDate,
                supervisingProvider: personName[0],
                followUpDate: selectedFollowUpDate,
                programType: programType
            });
            sessionStorage.setItem("wasReloaded", "true");
            const storageKey = `patient-timer-${patientId}`;
            sessionStorage.removeItem(storageKey);
            window.location.reload();
            return result;
        }
    };
    const handleChange = (event) => {
        const { target: { value }, } = event;
        if (value[0] === personName[0]) {
            setPersonName([]);
        }
        else {
            setPersonName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value);
        }
    };
    return (React.createElement(Dialog, { open: true },
        React.createElement(DialogTitle, { sx: { m: 0, p: 2 }, id: "customized-dialog-title" },
            "Pre-Submission Questions",
            React.createElement("button", { style: { marginLeft: 'auto', float: 'right' }, onClick: onRequestClose },
                React.createElement(Close, null))),
        React.createElement(DialogContent, { dividers: true },
            React.createElement(FormProvider, { ...methods },
                React.createElement("form", { onSubmit: handleSubmit(onNewPatientFormSubmit), noValidate: true },
                    React.createElement("div", { className: "mb-5", style: { width: '500px' } },
                        React.createElement("div", { className: "flex justify-between items-center" },
                            React.createElement("div", { style: { width: '100%' } },
                                React.createElement("div", { className: "row", style: { display: !programSelectorVisible ? 'none' : 'block' } },
                                    React.createElement("div", { style: { marginBottom: '5px', color: 'black', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', wordWrap: 'break-word' } }, "Billing Program"),
                                    React.createElement("fieldset", { style: { width: '100%' }, className: "text-xxs font-bold uppercase bg-gray-30 peer-checked:bg-blue-500 peer-checked:text-white" },
                                        React.createElement("div", { style: { width: '100%' }, className: 'inline-flex focus-within:ring-2 rounded-md' },
                                            React.createElement("div", { style: { flex: 1 } },
                                                React.createElement("input", { disabled: rpmProgramDisabled, type: "radio", id: "program-rpm", className: "peer sr-only", value: 'RPM', ...register('programType') }),
                                                React.createElement("label", { htmlFor: "program-rpm", className: clsx('text-xxs font-bold uppercase bg-gray-300 peer-checked:bg-blue-500 peer-checked:text-white text-center p-2 block', 'rounded-l-md') }, "RPM")),
                                            React.createElement("div", { style: { flex: 1 } },
                                                React.createElement("input", { disabled: ccmProgramDisabled, type: "radio", id: "program-ccm", className: "peer sr-only", value: "CCM", ...register('programType') }),
                                                React.createElement("label", { htmlFor: "program-ccm", className: clsx('text-xxs font-bold uppercase bg-gray-300 peer-checked:bg-blue-500 peer-checked:text-white text-center p-2 block', 'rounded-r-md') }, "CCM"))))),
                                React.createElement("div", { className: "row", style: { marginTop: '10px' } },
                                    React.createElement("div", { style: { color: 'black', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', wordWrap: 'break-word' } }, "Time Spent"),
                                    React.createElement("div", null,
                                        React.createElement(ReviewTimer, { patientId: patientId, draggable: false, overrideValue: overrideValue })),
                                    React.createElement("div", { className: 'flex', style: { alignItems: 'center', gap: '10px' } },
                                        React.createElement("div", { style: { color: '#00000099', fontSize: 14, fontFamily: 'Barlow', fontWeight: '400', whiteSpace: 'nowrap' } }, "Override Time Spent:"),
                                        React.createElement("fieldset", { style: { flex: 1 }, className: "text-xxs font-bold uppercase bg-gray-30 peer-checked:bg-blue-500 peer-checked:text-white" },
                                            React.createElement("div", { style: { width: '100%' }, className: 'inline-flex focus-within:ring-2 rounded-md' },
                                                React.createElement("div", { style: { flex: 1 } },
                                                    React.createElement("input", { type: "radio", id: "time-5", className: "peer sr-only", value: 5, ...register('timeSpent', {
                                                            onChange: (e) => {
                                                                const val = Number(e.target.value);
                                                                if (val > 0) {
                                                                    setOverrideValue(val);
                                                                }
                                                                else if (val === -1 && timeOther) {
                                                                    setOverrideValue(timeOther);
                                                                }
                                                                else {
                                                                    setOverrideValue(null);
                                                                }
                                                            },
                                                        }) }),
                                                    React.createElement("label", { htmlFor: "time-5", className: clsx('w-18 text-xxs font-bold uppercase bg-gray-300 peer-checked:bg-blue-500 peer-checked:text-white text-center p-2 block', 'rounded-l-md') }, "5 mins")),
                                                React.createElement("div", { style: { flex: 1 } },
                                                    React.createElement("input", { type: "radio", id: "time-10", className: "peer sr-only", value: 10, ...register('timeSpent') }),
                                                    React.createElement("label", { htmlFor: "time-10", className: clsx('w-18 text-xxs font-bold uppercase bg-gray-300 peer-checked:bg-blue-500 peer-checked:text-white text-center p-2 block', '') }, "10 mins")),
                                                React.createElement("div", { style: { flex: 1 } },
                                                    React.createElement("input", { type: "radio", id: "time-15", className: "peer sr-only", value: 15, ...register('timeSpent') }),
                                                    React.createElement("label", { htmlFor: "time-15", className: clsx('w-18 text-xxs font-bold uppercase bg-gray-300 peer-checked:bg-blue-500 peer-checked:text-white text-center p-2 block', '') }, "15 mins")),
                                                React.createElement("div", { style: { flex: 1 } },
                                                    React.createElement("input", { type: "radio", id: "time-20", className: "peer sr-only", value: 20, ...register('timeSpent') }),
                                                    React.createElement("label", { htmlFor: "time-20", className: clsx('w-18 text-xxs font-bold uppercase bg-gray-300 peer-checked:bg-blue-500 peer-checked:text-white text-center p-2 block', '') }, "20 mins")),
                                                React.createElement("div", { style: { flex: 1 } },
                                                    React.createElement("input", { type: "radio", id: "time-other", className: "peer sr-only", value: -1, ...register('timeSpent') }),
                                                    React.createElement("label", { htmlFor: "time-other", className: clsx('w-18 text-xxs font-bold uppercase bg-gray-300 peer-checked:bg-blue-500 peer-checked:text-white text-center p-2 block', 'rounded-r-md') }, "Other")))))),
                                React.createElement("div", { className: isTimeOther ? 'row' : 'row hidden' },
                                    "Other:",
                                    React.createElement("input", { type: 'number', placeholder: 'in minutes', ...register('timeOther') })),
                                React.createElement("div", { className: "row", style: { marginTop: '10px', marginBottom: '10px' } },
                                    React.createElement("div", { style: { marginBottom: '5px', width: '100%', color: 'black', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', wordWrap: 'break-word' } }, "Audio or Video Call?"),
                                    React.createElement("fieldset", { className: "text-xxs font-bold uppercase bg-gray-30 peer-checked:bg-blue-500 peer-checked:text-white" },
                                        React.createElement("div", { className: 'inline-flex focus-within:ring-2 rounded-md' },
                                            React.createElement("div", null,
                                                React.createElement("input", { type: "radio", id: "talk-yes", className: "peer sr-only", value: 'Yes', ...register('talkType') }),
                                                React.createElement("label", { htmlFor: "talk-yes", className: clsx('w-10 text-xxs font-bold uppercase bg-gray-300 peer-checked:bg-blue-500 peer-checked:text-white text-center p-2 block', 'rounded-l-md') }, "Yes")),
                                            React.createElement("div", null,
                                                React.createElement("input", { type: "radio", id: "talk-no", className: "peer sr-only", value: "No", ...register('talkType') }),
                                                React.createElement("label", { htmlFor: "talk-no", className: clsx('w-10 text-xxs font-bold uppercase bg-gray-300 peer-checked:bg-blue-500 peer-checked:text-white text-center p-2 block', 'rounded-r-md') }, "No"))))),
                                React.createElement("div", { className: "flex justify-between " },
                                    React.createElement("div", { style: { width: '100%', marginBottom: '15px' } },
                                        React.createElement("div", { style: { width: '100%', color: 'black', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', wordWrap: 'break-word' } }, "Billing Provider:"),
                                        React.createElement(FormControl, { sx: { width: '100%', textAlign: 'left' }, size: "small" },
                                            React.createElement(InputLabel, { id: "demo-multiple-checkbox-label" }, "Select Billing Provider"),
                                            React.createElement(Select, { labelId: "demo-multiple-checkbox-label", id: "demo-multiple-checkbox", multiple: true, value: personName, onChange: handleChange, input: React.createElement(OutlinedInput, { label: "Tag" }), renderValue: (selected) => selected.join(', '), MenuProps: MenuProps, size: 'small' }, providerNames.map((name) => (React.createElement(MenuItem, { key: name, value: name },
                                                React.createElement(Checkbox, { checked: personName.indexOf(name) > -1 }),
                                                React.createElement(ListItemText, { primary: name })))))))),
                                React.createElement("div", { className: "row", style: { marginTop: '10px', marginBottom: '10px' } },
                                    React.createElement(Grid, { container: true },
                                        React.createElement(Grid, { item: true, xs: 6 },
                                            React.createElement("div", { style: { color: 'black', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600' } }, "Activity Date:")),
                                        React.createElement(Grid, { item: true, xs: 6 },
                                            React.createElement("div", { style: { display: 'flex' } },
                                                React.createElement("div", { style: { color: 'black', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', marginRight: '10px' } }, selectedFollowUpDate ? 'Follow-Up Date (Optional)' : 'Follow-Up Date (Optional)'),
                                                React.createElement(CachedOutlined, { color: 'primary', onClick: () => setSelectedFollowUpDate(null) }))))),
                                React.createElement("div", { className: "row" },
                                    React.createElement(Grid, { container: true },
                                        React.createElement(Grid, { item: true, xs: 6 },
                                            React.createElement("div", { style: { width: '200px' } },
                                                React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                                                    React.createElement(DatePicker, { value: selectedDate, maxDate: dayjs(), onChange: (value) => {
                                                            setSelectedDate(value);
                                                        } })))),
                                        React.createElement(Grid, { item: true, xs: 6 },
                                            React.createElement("div", { style: { width: '200px' } },
                                                React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
                                                    React.createElement(DatePicker, { open: openFollowUpCalendar, onOpen: () => setOpenFollowUpCalendar(true), onClose: () => setOpenFollowUpCalendar(false), slotProps: {
                                                            textField: {
                                                                onClick: () => setOpenFollowUpCalendar(true),
                                                            },
                                                        }, value: selectedFollowUpDate, minDate: dayjs(), onChange: (value) => {
                                                            setSelectedFollowUpDate(value);
                                                        } })))))),
                                React.createElement(FormError, { errors: errors, name: "newpatient" })))),
                    React.createElement("div", { style: { display: disableDoneButtonByDate ? 'block' : 'none', color: 'var(--error-light, #EF5350)', fontSize: 14, fontFamily: 'Barlow', fontWeight: '600', marginRight: 'auto', marginLeft: 'auto' } }, "Due to the billing calendar, data analysis cannot be completed today. Please register this activity as 'Other' or complete the data analysis tomorrow."),
                    React.createElement(Button, { style: { width: '100%' }, variant: "contained", disabled: disableDoneButtonByDate ? true : isSubmitting, type: "submit", color: "primary", startIcon: React.createElement(Check, null) }, isSubmitting ? 'Submitting...' : 'Done'))))));
};
